import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["Render", "config", "index", "minCount", "total", "onDelete", "prefix"];
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import './index.less';
import { getFormValue } from '@/store';
import { RowBlockTitle, DeletableBlock, AddableBlock } from '../common';
import { updateFormKey } from '../../utils/tool';

function InsurantItem(props) {
  //
  const {
    Render,
    config,
    index,
    minCount,
    total,
    onDelete,
    prefix
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const relationFieldKey = 'holderRelation';
  const {
    attrs = {},
    formKey
  } = config[0]; // const relationValue = getFormValue(formKey, attrs.value);
  // const [relation, setRelation] = useState(relationValue);
  // if (relation === 'self') {
  //   const existingFields = getState('trailElementPolicyHolderFields') || [];
  //   config = config.filter((item) => {
  //     return item.component === relationFieldKey || existingFields.indexOf(item.component) === -1;
  //   });
  //   //
  // }

  function handleChange(value, name) {
    if (name.indexOf(relationFieldKey) !== -1) {
      // eslint-disable-next-line no-undef
      setRelation(value);
    } // handleCalcFieldsChange(value, name);

  }

  return /*#__PURE__*/React.createElement(DeletableBlock, {
    index: index,
    onDelete: onDelete,
    title: `${prefix}${index + 1}信息`,
    deletable: total > minCount,
    content: `删除${prefix}${index + 1}信息`,
    headerClassName: "delete-block-header"
  }, /*#__PURE__*/React.createElement(Render, _extends({}, rest, {
    components: config,
    onChange: (value, name) => {
      handleChange(value, name);
    }
  })));
}

export default function CalculateTrialMulti(props) {
  const {
    attrs,
    Render,
    children,
    label
  } = props;
  const {
    maxInsuredCount,
    minInsuredCount,
    defaultInsuredCount,
    prefix = '被保人',
    type,
    subType
  } = attrs;
  const minInsurant = minInsuredCount || 1;
  const defaultCount = defaultInsuredCount || 1;
  const maxInsurant = maxInsuredCount || 1;
  const ts = {
    holder: 0,
    insured: 1,
    common: 2
  };
  const _index = ts[type];
  const formValueKey = `trailElement[${_index}]`;
  const childrenConfig = updateFormKey(children, _index).concat({
    component: 'Hidden',
    attrs: {
      value: `${type}_${subType || ''}`
    },
    formKey: `${formValueKey}.__type`
  });
  const relationFieldKey = 'holderRelation';
  const [relation, setRelation] = useState(''); // 单被人的视图

  if (maxInsurant === 1) {
    let config = childrenConfig;

    if (relation === 'self') {
      config = childrenConfig.filter(item => {
        return item.component === relationFieldKey;
      });
    }

    config = updateFormKey(config, 0);
    return /*#__PURE__*/React.createElement(RowBlockTitle, {
      noGap: true,
      noBorder: false,
      showLabel: true,
      _label: label,
      title: label,
      className: "c-calculate-trial--single cc-row-block-title only"
    }, /*#__PURE__*/React.createElement(Render, {
      components: config
    }));
  }

  let initCount = defaultCount || 1;
  const trailElement = getFormValue(formValueKey);

  if (trailElement && trailElement.length) {
    initCount = trailElement.length;
  }

  if (initCount > maxInsurant) {
    initCount = maxInsurant;
  } else if (initCount < minInsurant) {
    initCount = minInsurant;
  }

  return /*#__PURE__*/React.createElement(RowBlockTitle, {
    noGap: true,
    showLabel: true,
    _label: label,
    title: label,
    className: "c-calculate-trial--multi"
  }, /*#__PURE__*/React.createElement(AddableBlock, {
    addButtonText: `添加${prefix}`,
    formValueArrayKey: formValueKey,
    maxCount: maxInsurant,
    minCount: minInsurant,
    initCount: initCount,
    config: childrenConfig,
    Component: InsurantItem,
    Render: Render,
    prefix: prefix,
    addButtonNoBorder: false // onCountChange={_doCalculate}

  }));
}